import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';
import SearchBar from '../../shared/searchBar/searchBar.component';
import columnDefs from '../../shared/columnDefinitions/taxAccountingForProvisionPage';

export const TaxAccountingPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    taxDescription: PropTypes.string,
    lineOfBusiness: PropTypes.string,
    enabledFlag: PropTypes.string,
    bsAccount: PropTypes.string,
    plAccount: PropTypes.string,
    reclassBsAccount: PropTypes.string,
    reclassPlAccount: PropTypes.string,
    goldId: PropTypes.string,
  })
);

class TaxAccounting extends PureComponent {
  static propTypes = {
    taxAccounting: TaxAccountingPropTypes,
  };

  state = {
    taxAccountingFilter: '',
  };

  setTaxAccountingFilter = filter => {
    this.setState({ taxAccountingFilter: filter });
  };

  unsetTaxAccountingFilter = () => {
    this.setState({ taxAccountingFilter: '' });
  };

  render() {
    const { taxAccounting } = this.props;
    const { taxAccountingFilter } = this.state;

    return (
      <div className="tax-rates container-fluid">
        <div className="search-bar-absolute">
          <SearchBar
            onCancel={this.unsetTaxAccountingFilter}
            onSearch={this.setTaxAccountingFilter}
            value={taxAccountingFilter}
          />
        </div>
        <div className="row">
          <div className="col">
            <div className="calc-settings-grid">
              <AgGrid
                columnDefs={columnDefs}
                rowData={taxAccounting}
                quickFilterText={taxAccountingFilter}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TaxAccounting;
